export let resultsRating = pageBootstrap => {
  const feedback = $('.results-negative-rating, .results-positive-rating');
  surveyRatingHandler(feedback, pageBootstrap);
};

let surveyRatingHandler = (rating, pageBootstrap) => {
  rating.click(function() {
    let resultRatingPath = $(this).parent().data('result-surveys-path');
    let resultRatingVal = $(this).data('result-rating-value');
    $.post(resultRatingPath, { positive_rating: resultRatingVal }, function() {
      pageBootstrap();
      $('.survey-group').fadeOut('fast', handleAjaxSuccess)
    })
  })
};

let handleAjaxSuccess = () => {
  var flashDiv = $('.flash-message').fadeIn('slow');
  setTimeout(function() {
    flashDiv.fadeOut('slow');
  }, 5000);
};
